import type {Employment, EmploymentDto } from '../types';

export function employmentFromDto(dto: EmploymentDto): Employment{
  return {
    id: dto.id,
    colour: dto.emty_colour,
    sort: dto.emty_sort,
    name: dto.emty_name ?? '---',
  };
}
